export default "__VITE_PUBLIC_ASSET__0f17a576__"